import classNames from 'classnames';

import { postCardTitle } from '../Post.css';

interface Props {
  title: string;
  className?: string;
}

const Title = ({ title, className }: Props) => {
  return <h4 className={classNames(postCardTitle, className)}>{title}</h4>;
};

export default Title;
